import { DriveFileMoveOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { grey } from "@mui/material/colors";
import { isEmpty } from "lodash";
import { useMemo, useState } from "react";
import { useForm, useFormState } from "react-final-form";
import { useSelector } from "react-redux";
import BasicModal from "../../modals/BasicModal";
import AssociatedBorrowerEntitiesTable from "../../tables/AssociatedBorrowerEntitiesTable";
const e = {
  _id: "697d34e4c0fcb58d4b652b32",
  applicantEntityPercentOwnership: 1,
  borrowerEntity: true,
  entityDocs: [],
  entityMembers: [
    {
      _id: "697d34e4c0fcb58d4b652b33",
      entityPercentOwnership: 1,
      firstName: "James",
      fullName: "",
      isGuarantor: true,
      lastName: "Oliva",
      middleInitial: "F",
      middleName: "Francesco",
      title: "Member",
    },
  ],
  entityName: "Example Entity Company With Docs",
  entityOrganizationDate: "2026-01-31T05:00:00",
  entityStateOfOrganization: "NY",
  entityType: "LLC",
  nestedEntities: [],
  parsedDocuments: [],
  trackRecord: [],
};
const RffImportBorrowerEntitiesFromReduxButton = () => {
  const keyName = "borrowerEntity";
  const [show, setShow] = useState(false);
  const form = useForm();

  const profile = useSelector((state) => state?.profile);
  const associatedEntities = profile?.associatedEntities || [];

  const handleImport = () => {
    setShow(true);
  };

  const onAddToForm = (entity) => {
    let borrowerEntityObject = {};
    borrowerEntityObject.entityName = entity.entityName;
    borrowerEntityObject.applicantEntityPercentOwnership =
      entity.applicantEntityPercentOwnership;
    borrowerEntityObject.entityStateOfOrganization =
      entity.entityStateOfOrganization;
    borrowerEntityObject.entityType = entity.entityType;
    borrowerEntityObject.entityOrganizationDate = entity.entityOrganizationDate;
    // Get current documents from Final Form

    // Update Final Form
    form.change(keyName, borrowerEntityObject);

    // Close modal
    setShow(false);
  };

  if (isEmpty(associatedEntities)) {
    return null;
  }

  return (
    <>
      <Button
        variant="text"
        color="inherit"
        onClick={handleImport}
        sx={{
          background: grey[200],
          px: 1,
          border: `1px solid #e0e0e0a8`,

          "&:hover": {
            background: grey[300],
          },

          ".MuiSvgIcon-root": {
            fontSize: "16px",
          },
        }}
        startIcon={<DriveFileMoveOutlined />}
      >
        Import Saved Entities
      </Button>
      <BasicModal
        show={show}
        maxWidth="lg"
        suppressBodyPadding
        onClose={() => setShow(false)}
        title="Select Entities to Import"
      >
        <AssociatedBorrowerEntitiesTable
          onRowClick={onAddToForm}
          entities={associatedEntities}
        />
      </BasicModal>
    </>
  );
};

export default RffImportBorrowerEntitiesFromReduxButton;
